import React from "react";
import cx from "classnames";
import {AiOutlineClose} from "react-icons/ai";

export function ModalHeader(props: { children: React.ReactNode, onClose: () => void, closeCrossSize?: number }) {
    return (<div
        className="sticky top-0 bg-white dark:bg-gray-800 p-4 z-10 border-b border-gray-200 dark:border-gray-700 w-full">
        <div className={cx("flex flex-row w-full justify-between items-center",)}>
            {props.children}
            <button onClick={props.onClose} className="float-right">
                <AiOutlineClose
                    className={"w-" + (props.closeCrossSize ?? 10) + " h-" + (props.closeCrossSize ?? 10)}/>
            </button>
        </div>
    </div>);
}